export class ProjectRoutePaths {
    static updateProject = 'projects';

    static removeProject(projectId: string) {
        return `projects/${projectId}`;
    }

    // @TODO that path should not use search params
    static inviteUser(projectId: string, searchParams: URLSearchParams) {
        return `projects/inviteUserToProject/${projectId}?${searchParams}`;
    }

    static availableRoles(projectId: string) {
        return `projects/inviteUserToProject/${projectId}/availableRoles`;
    }

    static projectDocuments(projectId: string) {
        return `projects/${projectId}/documents`;
    }
}
